import setTransition from './setTransition';
import transitionStart from './transitionStart';
import transitionEnd from './transitionEnd';
export default {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd
};


//////////////////
// WEBPACK FOOTER
// /home/arkaitz/Proiektuak/mx-merkatari-elkartea/bedrock/web/app/themes/sage/node_modules/swiper/esm/components/core/transition/index.js
// module id = 40
// module chunks = 0